import { StoreState } from 'state/types';
import { ShiftTimeRangeInputLegendReducerState } from './types';

const getState = (state: StoreState): ShiftTimeRangeInputLegendReducerState =>
  state.rangeInput.shiftTimeRangeInputLegend;

export const getIsOpened = (state: StoreState) => getState(state).isOpened;
